import React from 'react';
import { reportFocusMethod } from '@peloton/accessibility/reportFocusMethod';
import * as Env from '@members/env';

typeof window !== 'undefined' && reportFocusMethod(document);
const isLocalEnv = Env.isLocalEnv();
const isUatEnv = Env.isUatEnv();

// react-axe is an accessibility testing library that s
if (isLocalEnv || isUatEnv) {
  require.ensure(
    ['react-axe', 'react-dom'],
    require => {
      const axe = require('react-axe');
      const ReactDOM = require('react-dom');
      axe(React, ReactDOM, 1000);
    },
    _error => undefined,
    'vendors~react-axe',
  );
}
